import {
  IconBrandOffice,
  IconBulb,
  IconCalendarStats,
  IconFileCheck,
  IconFridge,
  IconHeartHandshake,
  IconMeteor,
  IconRadar,
  IconShieldCheck,
  IconSparkles,
  IconTool,
  IconUsers,
  IconWallet,
} from '@tabler/icons-react';
import { ExoticComponent } from 'react';

import { FeatureModuleKey } from 'src/Services/Hubspot/featureSurvey';

export interface FeaturePreviewContent {
  icon: ExoticComponent;
  translationPrefix: string;
  painsCount: number;
  benefitsCount: number;
  benefitIcons: ExoticComponent[];
  featuresCount: number;
  storiesCount: number;
}

export const FEATURE_PREVIEW_CONFIG: Record<FeatureModuleKey, FeaturePreviewContent> = {
  incidents: {
    icon: IconMeteor,
    translationPrefix: 'featurePreview.incidents',
    painsCount: 4,
    benefitsCount: 4,
    benefitIcons: [IconShieldCheck, IconUsers, IconFileCheck, IconRadar],
    featuresCount: 9,
    storiesCount: 3,
  },
  meetings: {
    icon: IconBrandOffice,
    translationPrefix: 'featurePreview.meetings',
    painsCount: 4,
    benefitsCount: 4,
    benefitIcons: [IconFileCheck, IconUsers, IconWallet, IconSparkles],
    featuresCount: 10,
    storiesCount: 3,
  },
  inventories: {
    icon: IconFridge,
    translationPrefix: 'featurePreview.inventories',
    painsCount: 4,
    benefitsCount: 4,
    benefitIcons: [IconShieldCheck, IconWallet, IconHeartHandshake, IconBulb],
    featuresCount: 10,
    storiesCount: 3,
  },
  resources: {
    icon: IconTool,
    translationPrefix: 'featurePreview.resources',
    painsCount: 4,
    benefitsCount: 4,
    benefitIcons: [IconCalendarStats, IconWallet, IconUsers, IconFileCheck],
    featuresCount: 9,
    storiesCount: 3,
  },
};
